import { FiCalendar, FiCheckCircle, FiTool, FiTruck, FiAlertTriangle } from 'react-icons/fi';
import { FaPlug } from 'react-icons/fa';

export const formatDate = value => value ? new Date(value.slice(0, 10) + 'T00:00:00').toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Not tracked';
export function fileUrl(value) {
  if (!value) return '';
  try {
    const base = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || window.location.origin;
    const url = new URL(value, base + '/');
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
  } catch { return ''; }
}
export function actionRow(row) {
  const priority = row.priority || 'Not tracked';
  const normalized = priority.toLowerCase();
  return { ...row, priority, dueDate: row.dueDate ? formatDate(row.dueDate) : 'Not tracked',
    priorityStyle: normalized === 'high' ? 'bg-red-50 text-red-600 border-red-100' : normalized === 'medium' ? 'bg-orange-50 text-orange-600 border-orange-100' : 'bg-slate-50 text-slate-500 border-slate-100' };
}
export function activityRow(row) {
  return { ...row, date: formatDate(row.date), author: 'by ' + row.author,
    icon: ({ check: FiCheckCircle, delivery: FiTruck, incident: FiAlertTriangle, equipment: FiTool })[row.kind] || FiCalendar,
    iconStyle: row.kind === 'incident' ? 'bg-red-50 text-red-500' : 'bg-emerald-50 text-emerald-600' };
}
export function eventRow(row) {
  return { ...row, date: formatDate(row.date), tagText: row.days === 0 ? 'Due today' : `In ${row.days} day${row.days === 1 ? '' : 's'}`,
    tagStyles: row.days <= 7 ? 'bg-red-50 text-red-600' : 'bg-orange-50 text-orange-600',
    iconStyles: row.kind === 'pat' ? 'bg-emerald-50 text-emerald-600' : 'bg-blue-50 text-blue-600', icon: row.kind === 'pat' ? FaPlug : FiCalendar };
}
